/* EmailRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const InputRadioControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.InputRadio;
const _ = require("lodash");

class BaseCreateRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("base-create-gl");
        this._rootElem.classList.add("de-email-veil");
        this._rootElem.component = this._model;

        this._nameField = new InputTextControl({
            darkTheme: true,
            placeholder: this.model.placeHolderTitle
        });
        this._confirmButton = new ButtonControl({
            label: "Send",
            darkTheme: true,
            disabled: true
        });
        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });

        this._reportTypeSel = new InputRadioControl({
            labelShown: true,
            horizontal: true,
            options: [
                {
                    label: "CSV",
                    value: "csv"
                },
                {
                    label: "PDF",
                    value: "pdf"
                },
                {
                    label: "JSON",
                    value: "json"
                }
            ],
            value: "csv",
            label: "Report format"
        });

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._messageBox = document.createElement("p");
        this._messageBox.innerText = this.model.message;

        this._errorBox = document.createElement("span");
        this._errorBox.classList.add("error", "hidden");
        this._errorBox.innerHTML = "Invalid email address.";
        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._confirmButton.on("UserClick", (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this)));
        this._cancelButton.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
        this._nameField.on("UserKeyDown", (this._checkForImpliedConfirm = this._checkForImpliedConfirm.bind(this)));
        this._nameField.on("UserValue", (this.checkValue = this.checkValue.bind(this)));
        this._reportTypeSel.on("UserValue", (this._onReportTypeSelChange = this._onReportTypeSelChange.bind(this)));
    }
    _unregisterListeners() {
        this._confirmButton.removeAllListeners("UserClick");
        this._nameField.removeAllListeners("UserKeyDown");
        this._nameField.removeAllListeners("UserValue");
        this._cancelButton.removeAllListeners("UserClick");
        this._reportTypeSel.removeAllListeners("UserValue");
    }
    _onConfirmButtonClick() {
        this._callCreateAction();
    }
    _onCancelButtonClick() {
        this._model.cancelAction();
    }
    _checkForImpliedConfirm(event) {
        if (event.keyCode === 13) {
            if (!_.isEmpty(this._nameField.getValue())) {
                this._callCreateAction();
            }
        }
    }
    checkValue(value) {
        this._errorBox.classList.add("hidden");
        if (_.isEmpty(value) || value.trim().length === 0) {
            this._confirmButton.disabled = true;
            return;
        }
        if (this._model.isValidEmail(value.trim())) {
            this._confirmButton.disabled = false;
            return;
        }
        this._confirmButton.disabled = true;
        this._errorBox.classList.remove("hidden");
    }
    _onReportTypeSelChange(val) {
        this._model.reportFormat = val || "csv";
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._nameField.shutdown(), this._confirmButton.shutdown(), this._cancelButton.shutdown(), this._reportTypeSel.shutdown()];

        return Promise.all(promArr).then(
            () => {
                this._nameField = undefined;
                this._confirmButton = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._messageBox.remove();
                this._messageBox = undefined;
                this._errorBox.remove();
                this._errorBox = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._cancelButton = undefined;
            },
            (err) => {
                this._model.logger.warn(err, "BaseCreateRenderer.shutdown() error");
            }
        );
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /*,reject*/) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                // if (this.model.isMessageProvided) { // messageBOx to errorBox
                this._rootElem.appendChild(this._messageBox);
                // }
                this._nameField.setValue(this._model._userEmail);
                this._rootElem.appendChild(this._nameField.renderer.rootElement);
                this._rootElem.appendChild(this._reportTypeSel.renderer.rootElement);
                this._rootElem.appendChild(this._errorBox);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
                setTimeout(() => {
                    this._nameField.focus();
                    this.checkValue(this._nameField.getValue());
                });
            }
            resolve();
        });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    _createControlWithLabel(control, label = "") {
        const elem = document.createElement("div");
        elem.classList.add("control-inp");
        elem.classList.add(label.toLowerCase().replace(" ", "_").replace(/\W/g, ""), "label");
        const labelEl = document.createElement("label");
        labelEl.innerText = label;
        elem.appendChild(labelEl);
        elem.appendChild(control.renderer.rootElement);
        return elem;
    }
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _callCreateAction() {
        this._model.createAction(this._nameField.getValue());
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = BaseCreateRenderer;
